/**
 * 获取图表组件类型
 * @param itemType
 */
export function normalizeChartOption(option: any, data: any) {
  if (!option) return undefined

  if (Array.isArray(data)) {
    if (option.xAxis && !option.xAxis.data?.length && option.xAxis.dataProp) {
      option.xAxis.data = data.map((d: any) => d[option.xAxis.dataProp])
    }

    if (option.yAxis && !option.yAxis.data?.length && option.yAxis.dataProp) {
      option.yAxis.data = data.map((d: any) => d[option.yAxis.dataProp])
    }

    if (Array.isArray(option.series)) {
      option.series.forEach((it: any, index: number) => {
        it.type = it.type

        if (data && it.dataProp) {
          it.data = data.map((d: any) => d[it.dataProp])
        }
      })
    }
  } else {
    if (option.xAxis && !option.xAxis.data?.length && option.xAxis.dataProp) {
      option.xAxis.data = data[option.xAxis.dataProp]
    }

    if (option.yAxis && !option.yAxis.data?.length && option.yAxis.dataProp) {
      option.yAxis.data = data[option.yAxis.dataProp]
    }

    if (Array.isArray(option.series)) {
      option.series.forEach((it: any, index: number) => {
        it.type = it.type

        if (data && it.dataProp) {
          it.data = data[it.dataProp]
        }
      })
    }
  }

  return option
}

type Attrs = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any
}

// Copied from
// https://github.com/vuejs/vue-next/blob/5a7a1b8293822219283d6e267496bec02234b0bc/packages/shared/src/index.ts#L40-L41
const onRE = /^on[^a-z]/
export const isOn = (key: string): boolean => onRE.test(key)

export function omitOn(attrs: Attrs): Attrs {
  const result: Attrs = {}
  for (const key in attrs) {
    if (!isOn(key)) {
      result[key] = attrs[key]
    }
  }

  return result
}
